import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { MilestoneLibraryLookupComponent } from './milestone-library-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [MilestoneLibraryLookupComponent],
  exports: [MilestoneLibraryLookupComponent]
})
export class MilestoneLibraryLookupModule { }
